import { useContext } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import returnsServices from '@/returns/services/services'

const useVariantSearch = ({ isUnifiedDashboard, variantsSkus = [], onChangeSkus }) => {
  const { info } = useContext(AppContext)
  const {
    fetchData: fetchVariants,
    data: variants,
    loading: gettingVariants,
  } = useFetch(returnsServices.getVariantsBySKU, {
    doInitialRequest: false,
  })

  const handleSearchVariants = async sku => {
    await fetchVariants({ storeId: isUnifiedDashboard ? null : info?.selectedStore?.id, sku })
  }

  const handleSelectVariant = variant => {
    const newSkus = new Set(variantsSkus)
    newSkus.add(variant.sku)
    onChangeSkus([...newSkus])
  }

  const handleDeleteVariant = sku => {
    onChangeSkus(variantsSkus.filter(s => s !== sku))
  }

  return {
    variants: variants || [],
    gettingVariants,
    handleSearchVariants,
    handleSelectVariant,
    handleDeleteVariant,
  }
}

export default useVariantSearch
